"use client";

import { ToastContainer } from "react-toastify";
import { useTheme } from "next-themes";
import { ZEND_CHAT_HEIGHT_IN_PX } from "@/app/common/consts/ui";

const ToastProvider = () => {
  const { resolvedTheme } = useTheme();

  return (
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      theme={resolvedTheme === "dark" ? "dark" : "light"}
      style={{ bottom: `${ZEND_CHAT_HEIGHT_IN_PX}px` }}
    />
  );
};

export default ToastProvider;
